<template>
  <router-link
    class="c-page-nav__link"
    :class="{'is-child': isChild, 'has-children': hasChildren}"
    :to="`/content${link.data.page_url}`"
  >
    <span>{{link.data.title}}</span>
  </router-link>
</template>

<script>
export default {
  name: 'page-navigation-link',

  props: {
    link: Object,
    isChild: Boolean,
    hasChildren: Boolean
  }
}
</script>

<style lang="scss">
.c-page-nav__link {
  display: inline-block;
  color: $colour-nhs-dark-grey;
  text-decoration: none;
  font-size: 14px;
  padding: 0 0 0.5em;
  clear: both;
  width: 100%;



  span {
    max-width: calc(100% - 0.5em - 10px);
  }


  &:hover {
    text-decoration: underline;
  }

  &.is-active {
    font-family: $font-frutiger-bold;
    color: $colour-nhs-blue;
  }
}
</style>
